// deps
import React, { memo } from "react";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// test-ids
import { GROUP_CART_ORDER_DATA_TEST_IDS } from "@swiggy-private/cart-test-ids";

// styles
import { Container } from "./ItemQtyNonEditable.style";

interface ItemQtyNonEditableProps {
    quantity: string;
    itemId: string;
}

const ItemQtyNonEditable = ({ quantity, itemId }: ItemQtyNonEditableProps) => {
    return (
        <Container data-testid={`${GROUP_CART_ORDER_DATA_TEST_IDS.NON_EDITABLE_QUANTITY}-${itemId}`}>
            <Text variant="V2.body1.neutral.regular" color="text_Med_Emphasis">
                {quantity} X
            </Text>
        </Container>
    );
};

export default memo(ItemQtyNonEditable);
